import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { type ExportConversationModalStore } from 'widgets/ExportConversationModal/store/exportConversationModalStore'

type IExportConversationsModalsActionsProps = {
  store: ExportConversationModalStore
}

export const ExportConversationsModalsActions: FC<IExportConversationsModalsActionsProps> =
  observer(({ store }) => {
    return (
      <Button
        typeBtn={'contained'}
        text={'Export'}
        onClick={store.onExport}
        disabled={store.disabled}
      />
    )
  })
